import React from "react";
import "./about.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import Fasilitasimages from "./Fasilitas";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const About = () => {
  const Aboutwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const settings1 = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className="about">
      <div className="containerabout">
        <div id="about" className="container-about">
          <h1>Sewa Apartemen Greenbay Harian, Bulanan, Tahunan</h1>
          <div className="container-desk">
            <div className="desk">
              Selamat Datang di Greenbay Apartement Pluit, dimana disini
              memiliki berbagai macam fasilitas menarik, seperti netflix,
              swimming pool, gym dll. Apartemen ini menyediakan berbagai macam
              pilihan seperti Studio, 1 Bedroom, 2 Bedroom yang bisa disewa
              secara haria,bulanan,tahunan.
            </div>
          </div>
          <div className="fasilitas-desk">
            <div className="fasilitas1">
              <div className="penawaranpoin">
                <FontAwesomeIcon
                  icon={faCheckDouble}
                  color="rgb(200, 169, 92)"
                />
                <span style={{color: "rgb(84, 84, 84)"}}>
                  &nbsp;&nbsp;Studio
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon
                  icon={faCheckDouble}
                  color="rgb(200, 169, 92)"
                />
                <span style={{color: "rgb(84, 84, 84)"}}>
                  &nbsp;&nbsp;1 Bedroom
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon
                  icon={faCheckDouble}
                  color="rgb(200, 169, 92)"
                />
                <span style={{color: "rgb(84, 84, 84)"}}>
                  &nbsp;&nbsp;2 Bedroom
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon
                  icon={faCheckDouble}
                  color="rgb(200, 169, 92)"
                />
                <span style={{color: "rgb(84, 84, 84)"}}>
                  &nbsp;&nbsp;Tersedia Sewa Harian, Mingguan, Bulanan
                </span>
              </div>
            </div>
          </div>
          <div className="button">
            <div className="container-wa">
              <button className="buttonpenawaran" onClick={Aboutwa}>
                <FontAwesomeIcon size="lg" icon={faWhatsapp} />
                Whatsapp
              </button>
            </div>
          </div>
        </div>
        <div className="slider-fasilitas">
          <Slider {...settings1}>
            {Fasilitasimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default About;
